import React from 'react';
import { Box, Typography, Paper, Grid, Card, CardContent, LinearProgress, List, ListItem, ListItemText, Chip } from '@mui/material';

const AuditCompliance: React.FC = () => {
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Audit & Compliance</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
        Check configurations against security policies and compliance standards
      </Typography>
      
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 4 }}>
          <Card>
            <CardContent>
              <Typography variant="h6">Compliance Score</Typography>
              <Typography variant="h3" color="primary">87%</Typography>
              <LinearProgress variant="determinate" value={87} sx={{ mt: 2 }} />
            </CardContent>
          </Card>
        </Grid>
        <Grid size={{ xs: 12, md: 8 }}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="h6" gutterBottom>Recent Audits</Typography>
            <List>
              <ListItem>
                <ListItemText primary="PCI-DSS Compliance Check" secondary="Passed - 2 days ago" />
                <Chip label="PASS" color="success" size="small" />
              </ListItem>
              <ListItem>
                <ListItemText primary="Security Best Practices" secondary="3 warnings - 5 days ago" />
                <Chip label="WARNING" color="warning" size="small" />
              </ListItem>
            </List>
          </Paper>
        </Grid>
      </Grid>
    </Box>
  );
};

export default AuditCompliance;